export const LEGAL_REGULATION_ROUTE = 'regulacje-prawne';
